export type UnknownRecord = Record<string, unknown>;

export function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function toStringArray(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return value
    .filter((entry): entry is string => typeof entry === "string")
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

export function readOptionalString(value: unknown): string | null {
  return typeof value === "string" ? value : null;
}

export function resolvePlanItemId(
  idValue: unknown,
  keyValue: unknown,
): string | null {
  const candidate =
    typeof idValue === "string" && idValue.length > 0 ? idValue : keyValue;
  if (typeof candidate !== "string") {
    return null;
  }
  const trimmed = candidate.trim();
  return trimmed.length > 0 ? trimmed : null;
}
